import { BaseGridRenderer, GridRenderOptions } from './base-grid-renderer';
import { SectionJsonData } from '../../models/element-types';
import { SectionType } from '../../models/section.model';
import { DomUtils } from '../../utils/dom-utils';

export interface SectionRenderOptions extends GridRenderOptions {
    type?: SectionType;
}

export class SectionRenderer extends BaseGridRenderer<SectionJsonData> {
    protected get defaultData(): SectionJsonData {
        return {
            id: '',
            type: 'section',
            sectionType: 'form'
        };
    }

    public override createNew(options?: SectionRenderOptions): HTMLElement {
        const data = { ...this.defaultData };
        data.id = DomUtils.generateUniqueElementId([]);
        if (options?.type) {
            data.sectionType = options.type;
        }
        return this.render(data, options);
    }

    protected renderElement(sectionJsonData: SectionJsonData): HTMLElement {
        const element = document.createElement('section');
        element.id = sectionJsonData.id;
        element.dataset['section'] = sectionJsonData.sectionType.toLowerCase();

        return element;
    }
}
